var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.75H12.803C12.552 6.75 12.319 6.62502 12.179 6.41602L11.07 4.75195C10.652 4.12495 9.952 3.75 9.198 3.75H7C4.381 3.75 2.25 5.881 2.25 8.5V15.5C2.25 18.119 4.381 20.25 7 20.25H17C19.619 20.25 21.75 18.119 21.75 15.5V11.5C21.75 8.881 19.619 6.75 17 6.75ZM20.25 15.5C20.25 17.292 18.792 18.75 17 18.75H7C5.208 18.75 3.75 17.292 3.75 15.5V8.5C3.75 6.708 5.208 5.25 7 5.25H9.19699C9.44799 5.25 9.68101 5.37498 9.82101 5.58398L10.93 7.24805C11.348 7.87505 12.048 8.25 12.802 8.25H17C18.792 8.25 20.25 9.708 20.25 11.5V15.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9da6b692.svg";
export { ForwardRef as ReactComponent };